module.exports = __webpack_public_path__ + "static/media/laborArticle3.aab63de4.jpg";